import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth/auth.service';
import { TempStateService } from '../../core/navigation/tempState.service';
import { User } from 'src/app/global-functions';
import { CustomMessagesService } from 'src/app/services/custom-messages.service';
import { MessageService } from '@progress/kendo-angular-l10n';
import { NotificationService } from '@progress/kendo-angular-notification';
import { TextBoxComponent } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit, AfterViewInit {
  @ViewChild("password") passwordInput: TextBoxComponent | undefined;

  public isPasswordVisible: boolean = false;
  formGroup: FormGroup;
  public errorMessage: string = '';
  returnUrl: string = '';
  passwordicon = 'textbox-hidden';
  logotipo = '../../../../assets/Logo_MicroioInovacao_2025_vertical_v3_cores.png';

  public customMsgService: CustomMessagesService;

  constructor(
    private auth: AuthService,
    private router: Router,
    private stateService: TempStateService,
    public msgService: MessageService,
    private notificationService: NotificationService
  ) {
    this.customMsgService = this.msgService as CustomMessagesService;
    this.formGroup = new FormGroup({
      login: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required)
    });
  }

  ngAfterViewInit() {
    this.hidePassword();
  }

  ngOnInit(): void {
    this.hidePassword();
    this.returnUrl = this.stateService.oldUrl || '/';
  }

  get login() {
    return this.formGroup.get('login');
  }

  get password() {
    return this.formGroup.get('password');
  }

  initForm() {
    this.formGroup = new FormGroup({
      login: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required)
    });
  }

  onSubmit() {
    if (this.formGroup.valid) {
      const authModel = this.formGroup.value;
      this.auth
        .authenticate(authModel.login, authModel.password)
        .subscribe((response: any) => {
          if (response) {
            this.auth.setToken(response.token);
            User.setTokenLocalStorage(response.token);
            this.router.navigate(['']);
          }
        }, (erro: any) => {
          this.notificationService.show({
            content: this.customMsgService.translate('loginSenhaInvalidos'),
            animation: { type: 'slide', duration: 500 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'error', icon: true },
            hideAfter: 4000
          });
        });
    }
  }

  selectedChange() {
    if (this.isPasswordVisible)
      this.hidePassword();
    else
      this.showPassword();
  }

  showPassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "text";
      this.isPasswordVisible = true;
      this.passwordicon = 'password';
    }
  }

  hidePassword() {
    if (this.passwordInput) {
      this.passwordInput.input.nativeElement.type = "password";
      this.isPasswordVisible = false;
      this.passwordicon = 'textbox-hidden';
    }
  }
}